.section {
  margin-top: var(--tuna-spacing-4);
  padding: var(--tuna-spacing-3);
  border-top: 1px solid var(--tuna-color-border);
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

.heading {
  font-size: var(--tuna-font-size-1);
  margin: 0;
  color: var(--tuna-color-text-secondary);
  font-weight: 600;
}

.links {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-2);
}

.link {
  /* Sized by ui-lib Button size="small"; class reserved for future tweaks. */
}
